import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import api from "@/lib/api";
import Countdown from "@/components/site/Countdown";
import { Zap, X } from "lucide-react";

const STORAGE_KEY = "fmaa_drop_dismissed";

export default function DropBanner() {
  const [drop, setDrop] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    api
      .get("/products/active-drop")
      .then((r) => setDrop(r.data || null))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!drop) return;
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored === drop.id) setDismissed(true);
  }, [drop]);

  if (!drop || dismissed) return null;
  if (pathname === "/checkout/success") return null;

  const dismiss = () => {
    sessionStorage.setItem(STORAGE_KEY, drop.id);
    setDismissed(true);
  };

  return (
    <div
      className="bg-[#FFC107] text-[#0A0A0A] border-b border-black/20 relative z-40"
      data-testid="drop-banner"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-2.5 flex items-center gap-4 flex-wrap">
        <span className="flex items-center gap-2 font-display tracking-[0.18em] text-base">
          <Zap size={16} fill="#0A0A0A" /> Live drop · {drop.city}
        </span>
        <span className="text-sm font-semibold truncate max-w-[40%]">{drop.name}</span>
        <div className="flex items-center gap-2 ml-auto">
          <span className="font-display text-xs tracking-[0.2em] uppercase">Ends in</span>
          <Countdown initialSeconds={drop.seconds_remaining} className="text-sm" />
          <Link
            to="/shop"
            className="bg-[#0A0A0A] text-white px-3 py-1.5 text-xs uppercase tracking-[0.18em] font-bold hover:bg-[#FF1E1E] transition-colors"
            data-testid="drop-banner-cta"
          >
            Cop it
          </Link>
          <button
            onClick={dismiss}
            className="ml-1 text-black/60 hover:text-black"
            aria-label="Dismiss"
            data-testid="drop-banner-dismiss"
          >
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}
